import React, {Component} from 'react';
import {Link} from "react-router-dom";
import { render } from 'react-dom';
import Header from "./header";
import Footer from "./footer";
import moment from 'moment';
import { Responsive, Container, Grid, Image, Pagination } from 'semantic-ui-react';

import axios from 'axios';
import "react-treeview/react-treeview.css"
import Config from '../../config';

const now = moment();

const ROOT_URL = Config.ROOT_URL;
class Photos extends Component {

    constructor(props){
        super(props);
        this.state = {
            dataWithPagination:{
                data:[],
                page:1,
                totalPages:1,
            },
        };
      }

    componentDidMount() {
        this.fetchData(1);
    }

    fetchData(page) {
        axios.get(`${ROOT_URL}/album?page=${page}`)
        .then(res => {
            const results = res.data;
            this.setState({
                dataWithPagination:results
            })
            console.log(results);
        });
    }
    

    render() {
        const {dataWithPagination} = this.state;
        return (
          <div className="Homepage">
            <Header page="aboutus" />
            <div className="homeContentWhite">
              <div className="homeContent">
    
                <Container>
                 <div>
                  {
                    dataWithPagination.data.map((item)=>{
                        console.log('item', item);
                      return (
                        <Link to={`/photos/${item.id}`}>
                            <div style={{width:'100%', marginBottom:40}}>
                                <img src={item.coverPhotoBaseUrl}></img>
                                <div style={{marginTop:20}}>
                                    {item.title}
                                </div>
                            </div>
                        </Link>
                      )
                    })
                  }
                 </div>
                 <div className="margin_top_m">
                  <Pagination
                      defaultActivePage={1}
                      totalPages={dataWithPagination.totalPages}
                      onPageChange={(event, paginationData)=>{
                        const activePage = paginationData.activePage;
                        this.fetchData(activePage);
                      }}
                    />
                  </div>
                </Container>
              </div>
            </div>
            <Footer />
          </div>
        );
      }
}

export default Photos;

/*
*/
